<template>
  <div>
    <BaseListPage
        :name="name"
        :no-condition="false"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        title="在庫移動指示一覧"
        table-class="row-clickable-table"
        icon="stock"
        @row-click="onRowClick">
      <span slot="headerAction"
          class="action_button">
        <el-dropdown
            v-show="$isFunctionShown(define.PermissionKeys.Stock.Move.List.NEW)"
            @command="actionCommand">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <el-dropdown-item
                :disabled="$isFunctionDisabled(define.PermissionKeys.Stock.Move.List.NEW)"
                :command="define.STOCK_MOVE_MODE.NEW">
              新規登録
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
      <template
          slot="tableOperation"
          slot-scope="{ row }">
        <BaseOperationTooltip
            v-if="showTooltip(row.row)"
            :list="getTooltipList(row.row)"
            class="operation-button"
            placement="bottom-end" />
      </template>
    </BaseListPage>
    <!-- 在庫調整ダイアログ -->
    <StockMoveInstructDialog
        :visible.sync="dialogVisible"
        :mode="mode"
        :uuid="uuid"
        @refreshList="() => refreshList()" />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapMutations, mapGetters } from 'vuex'

import common from '@/utils/common'
import message from '@/utils/message'
import * as config from '@/config'

import * as define from '@/define'
import * as query from '@/queries/stock'
import x from '@/components/mixins/mixin'

import BaseListPage from '@/components/organisms/BaseListPage'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import StockMoveInstructDialog from '@/components/pages/stock/StockMoveInstructDialog'

export default {
  name: 'StockMoveInstructList',
  components: {
    BaseListPage,
    BaseOperationTooltip,
    StockMoveInstructDialog
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      dialogVisible: false,
      localIsParentLoaded: false,
      mode: null,
      uuid: null
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.StockMove.listIndex,
      tableSetList: (state) => state.StockMove.tableSetList,
      tdLists: (state) => state.StockMove.tdLists
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'stockMoveInstructList'
    },
    storePath () {
      return 'StockMove'
    },
    saveKey () {
      return 'stockMoveCondition'
    },
    responsePath () {
      return 'data.stockMoveList.edges'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_STOCK_MOVE_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: '指示管理番号', path: 'node.stockMoveNo', sortable: 'move' },
        { type: 'String', label: '出荷先名称', path: 'node.name', sortable: 'move' },
        { type: 'String', label: '理由', path: 'node.reason', codeName: 'd_stock_move.reason', sortable: 'move' },
        { type: 'String', label: 'メモ', path: 'node.note', sortable: 'move' },
        { type: 'Date', dateFormat: 'YYYY/MM/DD', label: '出荷希望日', path: 'node.preferredShippingAt', sortable: 'move' },
        { type: 'Date', label: '送信日時', path: 'node.sendAt', sortable: 'move' },
        { type: 'Date', label: '作成日時', path: 'node.createdAt', sortable: 'move' },
        {
          itemKey: 'operation', isAvailable: true, isActive: true, fixed: 'right',
          type: 'Slot', label: '', path: 'operation', width: '60px', columnKey: 'operation', class: 'right',
          isShow: () => this.showOperation()
        }
      ]
    }
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'StockMove/tableSetList': this._tableSetList
      }
    })
  },
  methods: {
    ...mapMutations('StockMove', {
      updateListItem: 'update'
    }),
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.STOCK_MOVE_MODE.NEW:
          this.mode = define.STOCK_MOVE_MODE.NEW
          this.dialogVisible = true
          break
        default:
          break
      }
    },
    onRowClick (row, column, event) {
      this.mode = define.STOCK_MOVE_MODE.NORMAL
      this.uuid = row.node.uuid
      this.dialogVisible = true
    },
    /**
     * Tooltipの項目を返却する.
     * @param {Object} row 在庫移動情報
     * @return {Array}
     */
    getTooltipList (row) {
      return [
        {
          title: '削除',
          click: (item) => this.delete(row.node.uuid)
        }
      ]
    },
    /**
     * 在庫移動削除
     */
    delete (uuid) {
      this.$confirm('対象の未連携の移動指示を削除します。よろしいですか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // 削除APIを呼び出す
          await this.callApi(uuid)
          this.$notify.success('在庫移動指示を削除しました。')
          // 一覧画面データに反映する
          this.refreshList()
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_557() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {})
    },
    /**
     * 削除APIを呼び出す
     */
    async callApi (uuid) {
      const url = config.EC_STOCK_MOVE + '/' + uuid
      const method = 'delete'
      const response = await common.apiAxios(url, { method })
      return response
    },
    /**
     * 一覧画面のデータをリフレッシュする.
     */
    refreshList () {
      const queryCondition = this.searchConditions(this.storePath)
      this.updateListItem(queryCondition)
    },
    showTooltip (row) {
      return !row.node.sendAt
    },
    showOperation () {
      return this.$isFunctionShown(define.PermissionKeys.Stock.Move.List.DELETE) &&
        this.tdLists.findIndex((row) => !row.node.sendAt) >= 0
    }
  }
}
</script>
